var divider_viewer_rtlignore_default = {
  "divider-container": "_8Ve3F",
  "divider-container--double": "hqb-e",
  "divider": "_08sno",
  "divider--single": "D8AvR",
  "divider--double": "UyO49",
  "divider--dashed": "nm6pU",
  "divider--dotted": "l53kK",
  "divider--small": "_1wySR",
  "divider--small--mobile": "-BaeJ",
  "divider--medium": "zBKpb",
  "divider--large--mobile": "ptg6c",
  "divider--medium--mobile": "IKssE",
  "divider--large": "NCQDC",
  "divider--left": "sKMZi",
  "divider--center": "uNzuO",
  "divider--right": "_4BFxt",
  "divider--fill-parent": "Rt6YM",
  "svgFixerContainer": "NDs4V",
  "emptyChar": "HzFub"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
